import styled from 'styled-components';
import DefaultIcon from '../Assets/ReservationsIcon.svg';
import { Body1, Body5 } from "../style-comps/Common.styles";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 260px;
  height:200px;
  position: relative;
  gap: 10px;
  margin-bottom:8px;

  @media (max-width: 768px) {
     width:100%;
  }


`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  background-image: url(${(props) => props.icon || DefaultIcon});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ReservationsText = styled(Body1)`
  margin: 0;
`;

export const Count = styled.div`
  font-size: 36px;
  font-weight: bold;
  color: #000;
`;

// export const CountWrap = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: space-between;
// `;

export const BottomWrapper = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const GrowthTag = styled(Body5)`
  background-color: #61CBC9;
  color: #fff;
  border-radius: 8px;
  padding: 2px 16px;
  height: 18px;
`;

export const PercentageBar = styled.div`
  position: relative;
  background-color: #f0f0f0;
  border-radius: 8px;
  height: 44px;
  overflow: hidden;

  .filled {
    background-color: #ff5733;
    height: 100%;
    transition: width 0.3s ease-in-out;
  }
`;

export const PercentageText = styled.div`
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  pointer-events: none;
`;
